import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NavBar from '../../../components/NavBar';
import Cookies from 'js-cookie';
import {
	statusUsuario,
	requestBibliotecaDocumentosEdit,
	requestBibliotecaDocumentosAllList,
	requestBibliotecaDocumentosIdToken,
	bibliotecaRepositoriosTemas,
	requestBibliotecaRepositorios,
	bibliotecaPublicosAlvos,
	bibliotecaRepositoriosCategorias,
} from '../../../services/requests';

export default function GestaoEditArquivos() {
	const id = window.location.pathname.split('/').filter(Boolean).pop();
	const navigate = useNavigate();
	const fileInputRef = useRef(null);

	const [form, setForm] = useState({
		titulo: '',
		descricao: '',
		ativo: true,
		mes: '',
		ano: '',
		repositorios: [0],
		categorias: [0],
		temas: [0],
		publico_alvo: [0],
		arquivo_url: '',
		arquivo_preview: '',
		publico: false,
		competencia: '',
		serial: '',
		upload: null,
	});
	const [errors, setErrors] = useState({});
	const [showErrorMsg, setShowErrorMsg] = useState(false);
	const [isViewMode, setIsViewMode] = useState(false);
	const [successMsg, setSuccessMsg] = useState(false);
	const [formDisabled, setFormDisabled] = useState(false);
	const [isLogged, setIsLogged] = useState(null);
	const [loading, setLoading] = useState(false);

	// Estados para adicionar novas categorias e temas
	const [showAddCategoria, setShowAddCategoria] = useState(false);
	const [showAddTema, setShowAddTema] = useState(false);
	const [novaCategoria, setNovaCategoria] = useState('');
	const [novoTema, setNovoTema] = useState('');
	const [novoRepositorio, setNovoRepositorio] = useState('');
	const [categoriasAdicionadas, setCategoriasAdicionadas] = useState([]);
	const [repositoriosAdicionados, setRepositoriosAdicionados] = useState([]);
	const [temasAdicionadas, setTemasAdicionadas] = useState([]);
	const [novoPublicoAlvo, setNovoPublicoAlvo] = useState('');
	const [showAddPublicoAlvo, setShowAddPublicoAlvo] = useState(false);
	const [publicoAlvoAdicionados, setPublicoAlvoAdicionados] = useState([]);
	const [publicDisabled, setPublicDisabled] = useState(false);
	const [requisitionError, setRequisitionError] = useState('');

	// Exemplo de dados de repositórios únicos (substitua pelo seu fetch real)
	const [repositoriosUnicos, setRepositoriosUnicos] = useState([]);
	const [repositoriosApi, setRepositoriosApi] = useState([]);
	const [categoriasApi, setCategoriasApi] = useState([]);
	const [temasApi, setTemasApi] = useState([]);
	const [publicoAlvoApi, setPublicoAlvoApi] = useState([]);
	const [showAlert, setShowAlert] = useState([]);

	const handleUploadClick = () => {
		if (fileInputRef.current) {
			fileInputRef.current.click();
		}
	};

	const UploadIcone = require('../../../images/upload.png');
	const LinkIcone = require('../../../images/anexo-icone.png');

	const handleChange = (e) => {
		const { id, value, type, checked } = e.target;
		// Para selects, armazena o valor como string para exibição, mas converte para integer no envio
		setForm((prev) => ({
			...prev,
			[id]: type === 'checkbox' ? checked : value,
		}));
		setErrors((prev) => ({
			...prev,
			[id]: false,
		}));
	};

	// Adicione handleFileChange para upload
	const handleFileChange = (e) => {
		const file = e.target.files[0];
		setForm((prev) => ({
			...prev,
			upload: file,
		}));
		setErrors((prev) => ({
			...prev,
			upload: false,
		}));
	};

	// Função para buscar categorias e temas do repositório selecionado usando as funções corretas
	async function fetchCategoriasTemasPorRepositorio(repoPks) {
		const token = Cookies.get('user')
			? JSON.parse(Cookies.get('user')).token
			: null;
		try {
			const catRes = await Promise.all(
				repoPks.map((id) => bibliotecaRepositoriosCategorias(id, token))
			);

			const validResults = catRes.filter(Array.isArray);

			if (validResults.length > 0) {
				const common = validResults.reduce((acc, curr) => {
					const currIds = new Set(curr.map((item) => item.id));
					return acc.filter((item) => currIds.has(item.id));
				});

				let finalCat = Array.from(
					new Map(common.map((item) => [item.id, item])).values()
				);

				let result = Array.isArray(finalCat) ? finalCat : [];

				const filtrarCategoriasValidas = [
					...form.categorias,
					...categoriasAdicionadas,
				].filter((c) => result.some((r) => r.nome === c));
				setForm((prevForm) => {
					return {
						...prevForm,
						categorias: filtrarCategoriasValidas,
					};
				});
				setCategoriasApi(result);
			}
		} catch {
			setCategoriasApi([]);
		}

		try {
			const temaRes = await Promise.all(
				repoPks.map((id) => bibliotecaRepositoriosTemas(id, token))
			);

			const validResults = temaRes.filter(Array.isArray);

			if (validResults.length > 0) {
				const common = validResults.reduce((acc, curr) => {
					const currIds = new Set(curr.map((item) => item.id));
					return acc.filter((item) => currIds.has(item.id));
				});

				let finalTema = Array.from(
					new Map(common.map((item) => [item.id, item])).values()
				);

				const filtrartemasValidas = [
					...form.temas,
					...temasAdicionadas,
				].filter((c) => finalTema.some((r) => r.nome === c));
				setForm((prevForm) => {
					return {
						...prevForm,
						temas: filtrartemasValidas,
					};
				});

				setTemasApi(Array.isArray(finalTema) ? finalTema : []);
			}
		} catch {
			setTemasApi([]);
		}
		try {
			const publicoAlvoRes = await bibliotecaPublicosAlvos(
				repoPks,
				token
			);
			setPublicoAlvoApi(
				Array.isArray(publicoAlvoRes) ? publicoAlvoRes : []
			);
		} catch {
			setPublicoAlvoApi([]);
		}
	}

	// Normaliza 'form.repositorios' para um PK numérico aceito pela API
	const normalizeRepoPk = useCallback(
		(val) => {
			if (!val) return null;
			const n = Number(val);
			if (Number.isFinite(n) && n > 0) return n;
			const m = String(val).match(/repositorios\/(\d+)\/?/i);
			if (m) return Number(m[1]);
			const byName = repositoriosUnicos.find(
				(r) =>
					String(r.nome).trim().toLowerCase() ===
					String(val).trim().toLowerCase()
			);
			if (byName) {
				const nn = Number(byName.id);
				if (Number.isFinite(nn) && nn > 0) return nn;
			}
			return null;
		},
		[repositoriosUnicos]
	);

	// Buscar categorias/temas ao carregar e ao mudar o repositório
	useEffect(() => {
		if (Cookies.get('user')) {
			setShowAlert(false);
		} else {
			setShowAlert(true);
		}

		// const repoPk = normalizeRepoPk(form.repositorios);

		const repoPks = form?.repositorios
			?.map((r) => repositoriosUnicos?.find((o) => o?.nome === r)?.id)
			?.filter(Boolean);

		if (repoPks.length > 0) {
			fetchCategoriasTemasPorRepositorio(repoPks);
		}
	}, [form.repositorios, normalizeRepoPk, repositoriosUnicos]);

	const validate = () => {
		const newErrors = {};
		if (!form.titulo) newErrors.titulo = true;
		if (!form.descricao) newErrors.descricao = true;
		// Removido: validação de categorias, temas e outros campos relacionados a categorias/temas
		setErrors(newErrors);
		setShowErrorMsg(Object.keys(newErrors).length > 0);
		setRequisitionError('');
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!isLogged) {
			alert('Você precisa estar autenticado para editar arquivos.');
			return;
		}
		if (validate()) {
			setShowErrorMsg(false);
			setRequisitionError('');
			setFormDisabled(true);

			try {
				const userCookie = Cookies.get('user');
				const user = userCookie ? JSON.parse(userCookie) : null;
				const token = user?.token;

				// let body;

				// Converte os campos para inteiro antes de enviar
				const mesInt = form.mes ? Number(form.mes) : '';
				const anoInt = form.ano ? Number(form.ano) : '';
				const repositorioInt = form.repositorios
					? parseInt(form.repositorios)
					: '';
				const publicoBool = form.publico;

				// body = new FormData();
				// body.append("titulo", form.titulo || "");
				// body.append("descricao", form.descricao || "");
				// if (repositorioInt !== "" && !isNaN(repositorioInt))
				//   body.append("repositorios", repositorioInt);
				// body.append("publico", publicoBool);
				// if (mesInt !== "" && !isNaN(mesInt)) body.append("mes", mesInt);
				// if (anoInt !== "" && !isNaN(anoInt)) body.append("ano", anoInt);
				// body.append("ativo", form.ativo === true ? true : false);
				// if (form.upload) {
				//   body.append("arquivo", form.upload);
				// }

				// let categoriasList = [
				//   ...form.categorias,
				//   ...categoriasAdicionadas,
				// ]

				//  body.append("categorias", categoriasList.map(n => categoriasFiltradas.find(o => o.nome === n)?.id || n));

				// const temasList = [
				//   ...form.temas,
				//   ...temasAdicionadas,
				// ]
				//   body.append("temas", temasList.map(n => temasFiltrados.find(o => o.nome === n)?.id || n));

				// const publicoAlvoList = [
				//   ...form.publico_alvo,
				//   ...publicoAlvoAdicionados,
				// ]
				//   body.append("publico_alvo", publicoAlvoList.map(n => publicoAlvoFiltrados.find(o => o.nome === n)?.id || n));

				const body = {
					titulo: form.titulo || '',
					descricao: form.descricao || '',
					publico: publicoBool,
					ativo: form.ativo === true,
				};

				// Só adiciona se forem válidos numéricos
				if (repositorioInt !== '' && !isNaN(repositorioInt))
					body.repositorios = repositorioInt;

				if (mesInt !== '' && !isNaN(mesInt)) body.mes = mesInt;

				if (anoInt !== '' && !isNaN(anoInt)) body.ano = anoInt;

				// Adiciona arquivo se existir
				if (form.upload) body.arquivo = form.upload;

				// Monta listas
				const repositoriosList = [
					...form.repositorios,
					...repositoriosAdicionados,
				];
				body.repositorios = repositoriosList.map(
					(n) => repositoriosUnicos.find((o) => o.nome === n)?.id || n
				);

				const categoriasList = [
					...form.categorias,
					...categoriasAdicionadas,
				];
				body.categorias = categoriasList.map(
					(n) =>
						categoriasFiltradas.find((o) => o.nome === n)?.id || n
				);

				const temasList = [...form.temas, ...temasAdicionadas];
				body.temas = temasList.map(
					(n) => temasFiltrados.find((o) => o.nome === n)?.id || n
				);

				const publicoAlvoList = [
					...form.publico_alvo,
					...publicoAlvoAdicionados,
				];
				body.publico_alvo = publicoAlvoList.map(
					(n) =>
						publicoAlvoFiltrados.find((o) => o.nome === n)?.id || n
				);

				console.time(
					'⏳ Tempo da requisição requestBibliotecaDocumentosEdit'
				);
				console.log('🚀 Iniciando envio do documento...');
				setLoading(true);
				setFormDisabled(true);

				// 🔧 Faz a requisição dentro do try

				const result = await requestBibliotecaDocumentosEdit(
					id,
					body,
					token
				);

				console.timeEnd(
					'⏳ Tempo da requisição requestBibliotecaDocumentosEdit'
				);
				console.log('✅ Resposta recebida da API.');
				setLoading(false);

				// ✅ Somente aqui, em caso de sucesso
				if (!result.error) {
					setSuccessMsg(true);
					setTimeout(() => {
						setSuccessMsg(false);
						setFormDisabled(false);
						navigate('/gestao-biblioteca');
					}, 2000);
				} else {
					// console.log(body,Object.values(result?.error?.data)[0])

					if (
						form.categorias.length === 0 &&
						categoriasAdicionadas.length === 0
					) {
						setRequisitionError(
							'Selecione pelo menos uma categoria.'
						);
					} else {
						setRequisitionError(
							'Corrija os campos destacados e tente novamente.'
						);
					}

					setFormDisabled(false);
				}
			} catch (error) {
				// ❌ Cai aqui se a requisição falhar
				console.timeEnd(
					'⏳ Tempo da requisição requestBibliotecaDocumentosEdit'
				);
				setLoading(false);
				setFormDisabled(false);

				console.error('Erro ao editar documento:', error);
				//  setRequisitionError(Object.values(error?.response?.data)[0]);
				// setFormDisabled(false);
			}
		}
	};

	// Buscar dados do documento pelo id
	useEffect(() => {
		let token;
		if (Cookies.get('user')) {
			const user = JSON.parse(Cookies.get('user'));
			token = user?.token;
		}
		if (!id) return;
		async function fetchDocumento() {
			try {
				const dados = await requestBibliotecaDocumentosIdToken(
					id,
					token
				);

				setForm({
					titulo: dados.titulo || '',
					descricao: dados.descricao || '',
					mes: dados.mes ? String(dados.mes) : '',
					ano: dados.ano ? String(dados.ano) : '',
					repositorios: Array.isArray(dados.repositorios)
						? dados.repositorios.map((c) => String(c))
						: dados.repositorio
						? [String(dados.repositorio)]
						: [],
					categorias: Array.isArray(dados.categorias)
						? dados.categorias.map((c) => String(c))
						: dados.categoria
						? [String(dados.categoria)]
						: [],
					temas: Array.isArray(dados.temas)
						? dados.temas.map((t) => String(t))
						: dados.tema
						? [String(dados.tema)]
						: [],
					publico_alvo: Array.isArray(dados.publico_alvo)
						? dados.publico_alvo.map((t) => String(t))
						: dados.publico_alvo
						? [String(dados.publico_alvo)]
						: [],
					arquivo_url: dados.arquivo_url || '',
					arquivo_preview: dados.arquivo_preview || '',
					publico: dados.publico || false,
					ativo: dados.ativo === true ? true : false,
					competencia: dados.competencia || '',
					serial: dados.serial || '',
					upload: null,
				});
			} catch (error) {
				// erro silencioso
			}
		}
		fetchDocumento();
	}, [id]);

	// Checar login do usuário
	useEffect(() => {
		async function checkLogin() {
			const userCookie = Cookies.get('user');
			if (!userCookie) {
				setIsLogged(false);
				return;
			}
			try {
				const user = JSON.parse(userCookie);
				const token = user?.token;
				if (!token) {
					setIsLogged(false);
					return;
				}
				const status = await statusUsuario({ token });
				setIsLogged(status && !status.error);
			} catch {
				setIsLogged(false);
			}
		}
		checkLogin();
	}, []);

	// Carregar repositórios únicos ao montar (limitando id 1 a 4 e não exibindo nomes repetidos)
	useEffect(() => {
		async function fetchRepositorios() {
			try {
				const docsResp = await requestBibliotecaRepositorios();
				setRepositoriosUnicos(docsResp);
			} catch (error) {
				setRepositoriosUnicos([]);
			}
		}

		fetchRepositorios();
	}, []);

	const handleAddCategoria = () => {
		if (
			novaCategoria.trim() &&
			!categoriasAdicionadas.includes(novaCategoria.trim())
		) {
			setCategoriasAdicionadas([
				...categoriasAdicionadas,
				novaCategoria.trim(),
			]);
			setNovaCategoria('');
			setShowAddCategoria(false);
		}
	};

	const handleAddTema = () => {
		if (novoTema.trim() && !temasAdicionadas.includes(novoTema.trim())) {
			setTemasAdicionadas([...temasAdicionadas, novoTema.trim()]);
			setNovoTema('');
			setShowAddTema(false);
		}
	};

	const handleAddRepositorio = () => {
		if (
			novoRepositorio.trim() &&
			!repositoriosAdicionados.includes(novoRepositorio.trim())
		) {
			setRepositoriosAdicionados([
				...repositoriosAdicionados,
				novoRepositorio.trim(),
			]);
			setNovoRepositorio('');
			// setShowAddRepositorio(false);
		}
	};

	const removeRepositorio = (repositorioId) => {
		setForm((prev) => ({
			...prev,
			repositorios: prev.repositorios.filter((c) => c !== repositorioId),
		}));
	};

	const removeCategoria = (categoriaId) => {
		setForm((prev) => ({
			...prev,
			categorias: prev.categorias.filter((c) => c !== categoriaId),
		}));
	};

	const removeTema = (temaId) => {
		setForm((prev) => ({
			...prev,
			temas: prev.temas.filter((t) => t !== temaId),
		}));
	};

	const handleAddPublicoAlvo = () => {
		if (
			novoPublicoAlvo.trim() &&
			!publicoAlvoAdicionados.includes(novoPublicoAlvo.trim())
		) {
			setPublicoAlvoAdicionados([
				...publicoAlvoAdicionados,
				novoPublicoAlvo.trim(),
			]);
			setNovoPublicoAlvo('');
			setShowAddPublicoAlvo(false);
		}
	};
	const removePublicoAlvo = (publicoAlvoId) => {
		setForm((prev) => ({
			...prev,
			publico_alvo: prev.publico_alvo.filter((t) => t !== publicoAlvoId),
		}));
	};

	// Função para obter o nome da categoria pelo id
	const getCategoriaNome = (id) => {
		const cat = categoriasApi.find((c) => String(c.id) === String(id));
		return cat ? cat.nome : id;
	};

	const getPublicoAlvoNome = (id) => {
		const publicoAlvo = publicoAlvoApi.find(
			(p) => String(p.id) === String(id)
		);
		return publicoAlvo ? publicoAlvo.nome : id;
	};

	// Função para obter o nome do tema pelo id
	const getTemaNome = (id) => {
		const tema = temasApi.find((t) => String(t.id) === String(id));
		return tema ? tema.nome : id;
	};

	// Adicione estados auxiliares para o valor selecionado
	const [repositorioSelecionado, setRepositorioSelecionado] = useState('');
	const [categoriaSelecionada, setCategoriaSelecionada] = useState('');
	const [temaSelecionado, setTemaSelecionado] = useState('');
	const [publicoAlvoSelecionado, setPublicoAlvoSelecionado] = useState('');

	// Filtrar categorias pelo repositório selecionado (usando PK normalizado)
	const repoPkStr = String(
		(normalizeRepoPk(form.repositorios) ?? form.repositorios) || ''
	);
	const categoriasFiltradas = categoriasApi.filter((cat) => {
		if (typeof cat === 'object' && cat.repositorio_id !== undefined) {
			return String(cat.repositorio_id) === repoPkStr;
		}
		return true;
	});

	// Filtrar temas pelo repositório selecionado
	const temasFiltrados = temasApi.filter((tema) => {
		if (typeof tema === 'object' && tema.repositorio_id !== undefined) {
			return String(tema.repositorio_id) === repoPkStr;
		}
		return true;
	});

	// Filtrar publico_alvo pelo repositório selecionado
	const publicoAlvoFiltrados = publicoAlvoApi.filter((publicoAlvo) => {
		if (
			typeof publicoAlvo === 'object' &&
			publicoAlvo.repositorio_id !== undefined
		) {
			return String(publicoAlvo.repositorio_id) === repoPkStr;
		}
		return true;
	});

	return (
		<div className='flex flex-col mx-auto min-h-screen'>
			<NavBar />

			{showAlert ? (
				<section className='bg-[#004A80] mt-[150px] rounded-md w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%]  mx-auto my-auto'>
					<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
						<div className='mx-auto max-w-screen-sm text-center'>
							<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold text-primary-600'>
								401
							</h1>
							<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
								Acesso Negado
							</p>
							<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
								Você não possui permissão para acessar este
								campo. Entre em contato com o administrador(a)
								da sua unidade para solicitação de acesso.
							</p>
							<a
								href='/login'
								className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-xl px-5 py-2.5 text-center my-4'>
								<span> Volte para a Tela de Login</span>
							</a>
						</div>
					</div>
				</section>
			) : (
				<div className='font-inter flex flex-col flex-grow'>
					<div className='sm:top-[80px] mt-[80px] pb-4 bg-[#f0f4f8] w-full'>
						<div className='w-[90%] sm:w-[95%] mx-auto items-center max-w-[1136px]'>
							<div className='px-[2px] py-[18px]'>
								<p className='mx-auto md:mx-10 text-[#004A80] font-bold text-center text-2xl sm:text-3xl md:text-4xl mt-14 mb-12 font-roboto'>
									Edição de Arquivo
								</p>
							</div>
						</div>
					</div>
					<div className='w-full flex justify-center items-center'>
						<div className='w-[95%] max-w-[1136px] mx-auto px-2 sm:px-6 py-6 overflow-x-auto'>
							{!isLogged ? (
								<div className='text-[#D32F2F] text-center mb-4 font-medium'>
									Você precisa estar autenticado para editar
									arquivos.
								</div>
							) : (
								<>
									<button
										type='button'
										className='bg-[#004A80] text-white px-3 py-1.5 rounded-[8px] font-semibold text-sm shadow border border-[#E3E3E3] mb-4'
										onClick={() =>
											navigate('/gestao-biblioteca')
										}>
										voltar
									</button>
									<form
										className='flex flex-col items-center w-full mt-10'
										onSubmit={handleSubmit}>
										{/* Primeira linha */}
										<div className='flex flex-col sm:flex-row gap-4 sm:gap-6 mb-4 w-full'>
											<div className='flex flex-col flex-[3] min-w-[220px] sm:min-w-[400px]'>
												<label
													className='text-[#204A80] font-semibold mb-1'
													htmlFor='titulo'>
													Nome do Arquivo
												</label>
												<input
													id='titulo'
													type='text'
													placeholder='Nome do Documento'
													value={form.titulo}
													onChange={handleChange}
													disabled={
														formDisabled ||
														isViewMode
													}
													className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
														errors.titulo
															? 'border-[#D32F2F]'
															: 'border-[#E3E3E3]'
													} ${
														isViewMode
															? 'bg-[#42B9EB] text-[#757575]'
															: ''
													}`}
												/>
											</div>
											<div className='flex flex-col flex-1 min-w-[80px]'>
												<label
													className='text-[#204A80] font-semibold mb-1'
													htmlFor='mes'>
													Mês
												</label>
												<select
													id='mes'
													value={form.mes}
													onChange={handleChange}
													disabled={
														formDisabled ||
														isViewMode
													}
													className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
														errors.mes
															? 'border-[#D32F2F]'
															: 'border-[#E3E3E3]'
													} ${
														isViewMode
															? 'bg-[#42B9EB] text-[#757575]'
															: ''
													}`}>
													<option
														value=''
														disabled
														hidden>
														Selecione
													</option>
													<option value='1'>
														Janeiro
													</option>
													<option value='2'>
														Fevereiro
													</option>
													<option value='3'>
														Março
													</option>
													<option value='4'>
														Abril
													</option>
													<option value='5'>
														Maio
													</option>
													<option value='6'>
														Junho
													</option>
													<option value='7'>
														Julho
													</option>
													<option value='8'>
														Agosto
													</option>
													<option value='9'>
														Setembro
													</option>
													<option value='10'>
														Outubro
													</option>
													<option value='11'>
														Novembro
													</option>
													<option value='12'>
														Dezembro
													</option>
												</select>
											</div>
											<div className='flex flex-col flex-1 min-w-[60px]'>
												<label
													className='text-[#204A80] font-semibold mb-1'
													htmlFor='ano'>
													Ano
												</label>
												<select
													id='ano'
													value={form.ano}
													onChange={handleChange}
													disabled={
														formDisabled ||
														isViewMode
													}
													className={`bg-white border rounded-[8px] px-3 py-2  outline-none w-full ${
														errors.ano
															? 'border-[#D32F2F]'
															: 'border-[#E3E3E3]'
													} ${
														isViewMode
															? 'bg-[#42B9EB] text-[#757575]'
															: ''
													}`}>
													<option
														value=''
														disabled
														hidden>
														Selecione o ano
													</option>
													{Array.from(
														{ length: 40 },
														(_, i) => {
															const year =
																1997 + i;
															return (
																<option
																	key={year}
																	value={
																		year
																	}>
																	{year}
																</option>
															);
														}
													)}
												</select>
											</div>
										</div>

										{/* Segunda linha */}
										<div className='flex flex-col sm:flex-row gap-4 sm:gap-6 mb-4 w-full'>
											<div className='flex flex-col flex-1 min-w-[120px] sm:min-w-[180px]'>
												<label
													className='text-[#204A80] font-semibold mb-1'
													htmlFor='local_documento'>
													Local do Documento
												</label>
												{/* {console.log(repoPkStr)} */}
												<div className='flex gap-2'>
													<select
														id='repositorios'
														defaultValue=''
														onChange={(e) => {
															setRepositorioSelecionado(
																repositoriosUnicos?.find(
																	(item) =>
																		item?.id ===
																		Number(
																			e
																				.target
																				.value
																		)
																)?.nome || ''
															);
														}}
														className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
															errors.repositorios
																? 'border-[#D32F2F]'
																: 'border-[#E3E3E3]'
														} ${
															isViewMode
																? 'bg-[#42B9EB] text-[#757575]'
																: ''
														}`}
														disabled={
															formDisabled ||
															isViewMode
														}>
														<option
															disabled
															hidden
															value=''>
															Selecione um
															repositório
														</option>
														{repositoriosUnicos.map(
															(repositorio) => (
																<option
																	key={
																		repositorio.id
																	}
																	value={
																		repositorio.id
																	}>
																	{
																		repositorio.nome
																	}
																</option>
															)
														)}
													</select>
													<button
														type='button'
														className='border border-[#E3E3E3] rounded-[8px] px-2 py-1 bg-white text-[#204A80]'
														disabled={
															!repositorioSelecionado ||
															isViewMode
														}
														onClick={() => {
															if (
																repositorioSelecionado &&
																!form.repositorios.includes(
																	repositorioSelecionado
																)
															) {
																setForm(
																	(prev) => ({
																		...prev,
																		repositorios:
																			[
																				...prev.repositorios,
																				repositorioSelecionado,
																			],
																	})
																);
																setRepositorioSelecionado(
																	''
																);
															}
														}}>
														+
													</button>
												</div>

												{form.repositorios.length >
													0 && (
													<div className='flex flex-wrap gap-2 mt-2'>
														{form.repositorios.map(
															(
																repositorioId,
																index
															) => (
																<span
																	key={`${repositorioId}-${index}`}
																	className={`bg-[#e3f7fd] px-2 py-1 rounded text-xs flex items-center`}>
																	{
																		repositorioId
																	}
																	{!isViewMode && (
																		<button
																			type='button'
																			onClick={() =>
																				removeRepositorio(
																					repositorioId
																				)
																			}
																			className='ml-1 text-[#D32F2F] text-xs'>
																			x
																		</button>
																	)}

																	{/* {console.log(categoriasFiltradas.find((c) => c.nome === categoriaId ))} */}
																</span>
															)
														)}
														{repositoriosAdicionados.map(
															(rep, idx) => {
																// Tenta encontrar o nome da categoria pelo id ou string
																const repositorioOBJ =
																	repositoriosUnicos.find(
																		(r) =>
																			String(
																				r.id
																			) ===
																				String(
																					rep
																				) ||
																			r.nome ===
																				rep
																	);
																const nomeExibir =
																	repositorioOBJ
																		? repositorioOBJ.nome
																		: rep;
																return (
																	<span
																		key={`adicionada-${rep}-${idx}`}
																		className='bg-[#e3f7fd] text-[#204A80] px-2 py-1 rounded text-xs flex items-center'>
																		{
																			nomeExibir
																		}
																		{!isViewMode && (
																			<button
																				type='button'
																				onClick={() => {
																					setRepositoriosAdicionados(
																						repositoriosAdicionados.filter(
																							(
																								r
																							) =>
																								r !==
																								rep
																						)
																					);
																				}}
																				className='ml-1 text-[#D32F2F] text-xs'>
																				x
																			</button>
																		)}
																	</span>
																);
															}
														)}
													</div>
												)}
											</div>

											<div className='flex flex-col flex-1 min-w-[120px] sm:min-w-[100px] max-w-[180px]'>
												<label
													className='text-[#131518] font-semibold mb-1'
													htmlFor='publico'>
													Repositório
												</label>
												<div className='flex flex-row items-center gap-2'>
													<select
														id='publico'
														disabled={
															formDisabled ||
															isViewMode ||
															publicDisabled ||
															form.ativo === false
														}
														value={
															form.publico ===
															true
																? 'true'
																: 'false'
														}
														onChange={(e) => {
															setForm((prev) => ({
																...prev,
																publico:
																	e.target
																		.value ===
																	'true',
															}));
															setErrors(
																(prev) => ({
																	...prev,
																	publico: false,
																})
															);
														}}
														className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
															errors.publico
																? 'border-[#D32F2F]'
																: 'border-[#E3E3E3]'
														} ${
															publicDisabled
																? 'border-[#F4F4F4] text-[#204A80]'
																: ''
														}`}>
														<option value='true'>
															Público
														</option>
														<option value='false'>
															Privado
														</option>
													</select>
													{/* <span className="ml-2 text-[#204A80] text-sm font-semibold">
                          {form.publico === true ? "Público" : "Privado"}
                        </span> */}
												</div>
											</div>
											<div className='flex flex-col flex-1 min-w-[120px] sm:min-w-[180px]'>
												<label className='text-[#204A80] font-semibold mb-1'>
													Upload do Arquivo
												</label>
												<div className='flex flex-row items-center border rounded-[8px] px-3 py-2'>
													<input
														type='file'
														ref={fileInputRef}
														style={{
															display: 'none',
														}}
														disabled={
															formDisabled ||
															isViewMode
														}
														onChange={
															handleFileChange
														}
														accept='.pdf'
													/>
													<input
														type='text'
														placeholder='Selecione um arquivo...'
														disabled
														value={
															form.upload
																? form.upload
																		.name
																: form.serial ||
																  ''
														}
														className='bg-white  outline-none w-full text-[#757575]'
													/>
													<button
														type='button'
														onClick={
															handleUploadClick
														}
														disabled={
															isViewMode ||
															formDisabled
														}
														className='ml-2'>
														<img
															src={UploadIcone}
															alt='Upload'
															className='w-6 h-auto'
														/>
													</button>
													<a
														href={
															form.arquivo_preview
														}
														target='_blank'
														rel='noopener noreferrer'
														className='ml-2'>
														<img
															src={LinkIcone}
															alt='Link'
															className='w-6 h-auto'
														/>
													</a>
												</div>
												<span className='text-[#42B9EB] text-xs mt-1'>
													link do arquivo
												</span>
											</div>
											{/* STATUS */}
											<div
												className={` flex flex-col flex-1 max-w-[145px] justify-start gap-2.5`}>
												<label
													className={`text-[#204A80] flex  font-semibold mb-1`}
													htmlFor='publico'>
													Status
												</label>
												<div className='flex flex-row items-center gap-2'>
													<div
														className={`flex transition-all duration-300 gap-4 ${
															errors.ativo ===
															true
																? 'border-[#d61d1d] border-[1px] p-1 rounded-md'
																: ''
														} `}>
														<label
															htmlFor='ativo'
															className='flex gap-1.5 text-[#757575]'>
															<input
																checked={
																	form.ativo ===
																	true
																}
																onChange={(
																	e
																) => {
																	setForm(
																		(
																			prev
																		) => ({
																			...prev,
																			ativo: true,
																		})
																	);
																	setErrors(
																		(
																			prev
																		) => ({
																			...prev,
																			ativo: false,
																		})
																	);
																	setPublicDisabled(
																		false
																	);
																}}
																type='radio'
																name='status'
																value='true'
																id='ativo'></input>
															<p>Ativo</p>
														</label>
														<label
															htmlFor='inativo'
															className='flex gap-1.5 text-[#757575]'>
															<input
																checked={
																	form.ativo ===
																	false
																}
																onChange={(
																	e
																) => {
																	setForm(
																		(
																			prev
																		) => ({
																			...prev,
																			publico: false,
																			ativo: false,
																		})
																	);
																	setErrors(
																		(
																			prev
																		) => ({
																			...prev,
																			publico: false,
																			ativo: false,
																		})
																	);
																	setPublicDisabled(
																		true
																	);
																}}
																type='radio'
																name='status'
																value='false'
																id='ativo'></input>
															<p>Inativo</p>
														</label>
													</div>
												</div>
											</div>
										</div>
										{/* Terceira linha */}
										<div className='flex flex-col sm:flex-row gap-4 sm:gap-6 mb-4 w-full'>
											<div className='flex flex-col flex-1 min-w-[120px] sm:min-w-[180px]'>
												<label
													className='text-[#204A80] font-semibold mb-1'
													htmlFor='categoria'>
													Categoria
												</label>
												<div className='flex flex-row items-center gap-2'>
													<select
														id='categoria'
														value={
															categoriaSelecionada
														}
														onChange={(e) => {
															setCategoriaSelecionada(
																e.target.value
															);
														}}
														disabled={
															formDisabled ||
															isViewMode ||
															categoriasFiltradas.length ===
																0
														}
														className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
															errors.categorias ||
															(form.categorias
																.length === 0 &&
																categoriasAdicionadas.length ===
																	0)
																? 'border-[#D32F2F]'
																: 'border-[#E3E3E3]'
														} ${
															isViewMode
																? 'bg-[#42B9EB] text-[#757575]'
																: ''
														}`}>
														{/* {console.log(categoriasFiltradas.length)} */}
														<option
															value=''
															disabled
															hidden>
															{categoriasFiltradas.length !==
															0
																? 'Adicionar categoria'
																: 'Nenhuma Categoria Disponivel'}
														</option>
														{categoriasFiltradas.map(
															(cat) => (
																<option
																	key={cat.id}
																	value={
																		cat.nome
																	}>
																	{cat.nome}
																</option>
															)
														)}
													</select>
													<button
														type='button'
														className='border border-[#E3E3E3] rounded-[8px] px-2 py-1 bg-white text-[#204A80]'
														disabled={
															!categoriaSelecionada ||
															isViewMode
														}
														onClick={() => {
															if (
																categoriaSelecionada &&
																!form.categorias.includes(
																	categoriaSelecionada
																)
															) {
																setForm(
																	(prev) => ({
																		...prev,
																		categorias:
																			[
																				...prev.categorias,
																				categoriaSelecionada,
																			],
																	})
																);
																setCategoriaSelecionada(
																	''
																);
															}
														}}>
														+
													</button>
												</div>
												{showAddCategoria &&
													!isViewMode && (
														<div className='flex items-center gap-2 mt-2'>
															<button
																type='button'
																onClick={
																	handleAddCategoria
																}
																className='bg-[#42B9EB] text-white rounded-[8px] px-3 py-2 text-sm font-bold'>
																Adicionar
															</button>
														</div>
													)}
												{form.categorias.length > 0 && (
													<div className='flex flex-wrap gap-2 mt-2'>
														{/* {categoriasFiltradas.length === 0 && (
                            <span className="text-[#D32F2F] text-sm">
                              Selecione pelo menos uma categoria.
                            </span>
                          )} */}
														{form.categorias.map(
															(
																categoriaId,
																index
															) => (
																<span
																	key={`${categoriaId}-${index}`}
																	className={`bg-[#e3f7fd] px-2 py-1 rounded text-xs flex items-center`}>
																	{categoriasApi.some(
																		(c) =>
																			String(
																				c.id
																			) ===
																			String(
																				categoriaId
																			)
																	)
																		? getCategoriaNome(
																				categoriaId
																		  )
																		: categoriaId}
																	{!isViewMode && (
																		<button
																			type='button'
																			onClick={() =>
																				removeCategoria(
																					categoriaId
																				)
																			}
																			className='ml-1 text-[#D32F2F] text-xs'>
																			x
																		</button>
																	)}

																	{/* {console.log(categoriasFiltradas.find((c) => c.nome === categoriaId ))} */}
																</span>
															)
														)}
														{categoriasAdicionadas.map(
															(cat, idx) => {
																// Tenta encontrar o nome da categoria pelo id ou string
																const categoriaObj =
																	categoriasApi.find(
																		(c) =>
																			String(
																				c.id
																			) ===
																				String(
																					cat
																				) ||
																			c.nome ===
																				cat
																	);
																const nomeExibir =
																	categoriaObj
																		? categoriaObj.nome
																		: cat;
																return (
																	<span
																		key={`adicionada-${cat}-${idx}`}
																		className='bg-[#e3f7fd] text-[#204A80] px-2 py-1 rounded text-xs flex items-center'>
																		<p className='text-[#204A80] flex flex-col'>
																			{
																				nomeExibir
																			}
																		</p>

																		{!isViewMode && (
																			<button
																				type='button'
																				onClick={() => {
																					setCategoriasAdicionadas(
																						categoriasAdicionadas.filter(
																							(
																								c
																							) =>
																								c !==
																								cat
																						)
																					);
																				}}
																				className='ml-1 text-[#D32F2F] text-xs'>
																				x
																			</button>
																		)}
																	</span>
																);
															}
														)}
													</div>
												)}
											</div>
											<div className='flex flex-col flex-1 min-w-[120px] sm:min-w-[180px]'>
												<label
													className='text-[#204A80] font-semibold mb-1'
													htmlFor='tema'>
													Tema
												</label>
												<div className='flex flex-row items-center gap-2'>
													<select
														id='tema'
														value={temaSelecionado}
														onChange={(e) =>
															setTemaSelecionado(
																e.target.value
															)
														}
														disabled={isViewMode}
														className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
															errors.temas
																? 'border-[#D32F2F]'
																: 'border-[#E3E3E3]'
														} ${
															isViewMode
																? 'bg-[#42B9EB] text-[#757575]'
																: ''
														}`}>
														<option
															value=''
															disabled
															hidden>
															Adicionar tema
														</option>
														{temasFiltrados.map(
															(tema) => (
																<option
																	key={
																		tema.id
																	}
																	value={
																		tema.nome
																	}>
																	{tema.nome}
																</option>
															)
														)}
													</select>
													<button
														type='button'
														className='border border-[#E3E3E3] rounded-[8px] px-2 py-1 bg-white text-[#204A80]'
														disabled={
															!temaSelecionado ||
															isViewMode
														}
														onClick={() => {
															if (
																temaSelecionado &&
																!form.temas.includes(
																	temaSelecionado
																)
															) {
																setForm(
																	(prev) => ({
																		...prev,
																		temas: [
																			...prev.temas,
																			temaSelecionado,
																		],
																	})
																);
																setTemaSelecionado(
																	''
																);
															}
														}}>
														+
													</button>
												</div>
												{showAddTema && !isViewMode && (
													<div className='flex items-center gap-2 mt-2'>
														<input
															type='text'
															placeholder='Novo tema'
															value={novoTema}
															onChange={(e) =>
																setNovoTema(
																	e.target
																		.value
																)
															}
															className='bg-white border border-[#E3E3E3] rounded-[8px] px-3 py-2 outline-none flex-1'
															onKeyPress={(e) =>
																e.key ===
																	'Enter' &&
																handleAddTema()
															}
														/>
														<button
															type='button'
															onClick={
																handleAddTema
															}
															className='bg-[#42B9EB] text-white rounded-[8px] px-3 py-2 text-sm font-bold'>
															Adicionar
														</button>
													</div>
												)}
												{form.temas.length > 0 && (
													<div className='flex flex-wrap gap-2 mt-2'>
														{form.temas.map(
															(temaId, index) => (
																<span
																	key={`${temaId}-${index}`}
																	className={`bg-[#e3f7fd] px-2 py-1 rounded text-xs flex items-center`}>
																	{/* {console.log(temasFiltrados, temaId, getTemaNome(temaId))} */}
																	{temasApi.some(
																		(t) =>
																			String(
																				t.id
																			) ===
																			String(
																				temaId
																			)
																	)
																		? getTemaNome(
																				temaId
																		  )
																		: temaId}
																	{!isViewMode && (
																		<button
																			type='button'
																			onClick={() =>
																				removeTema(
																					temaId
																				)
																			}
																			className='ml-1 text-[#D32F2F] text-xs'>
																			x
																		</button>
																	)}
																</span>
															)
														)}

														{temasAdicionadas.map(
															(tema, idx) => (
																<span
																	key={`adicionada-tema-${tema}-${idx}`}
																	className='bg-[#e3f7fd] text-[#204A80] px-2 py-1 rounded text-xs flex items-center'>
																	{tema}
																	{!isViewMode && (
																		<button
																			type='button'
																			onClick={() => {
																				setTemasAdicionadas(
																					temasAdicionadas.filter(
																						(
																							t
																						) =>
																							t !==
																							tema
																					)
																				);
																			}}
																			className='ml-1 text-[#D32F2F] text-xs'>
																			x
																		</button>
																	)}
																</span>
															)
														)}
													</div>
												)}
											</div>

											{/* PUBLICO ALVO */}
											<div className='flex flex-col flex-1 min-w-[120px] sm:min-w-[180px]'>
												<label
													className='text-[#204A80] font-semibold mb-1'
													htmlFor='publico_alvo'>
													Público-Alvo
												</label>
												<div className='flex flex-row items-center gap-2'>
													<select
														id='publico_alvo'
														value={
															publicoAlvoSelecionado
														}
														onChange={(e) =>
															setPublicoAlvoSelecionado(
																e.target.value
															)
														}
														disabled={isViewMode}
														className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
															errors.publico_alvo
																? 'border-[#D32F2F]'
																: 'border-[#E3E3E3]'
														} ${
															isViewMode
																? 'bg-[#42B9EB] text-[#757575]'
																: ''
														}`}>
														<option
															value=''
															disabled
															hidden>
															Adicionar
															público-alvo
														</option>
														{publicoAlvoFiltrados.map(
															(publico) => (
																<option
																	key={
																		publico.id
																	}
																	value={
																		publico.nome
																	}>
																	{
																		publico.nome
																	}
																</option>
															)
														)}
													</select>
													<button
														type='button'
														className='border border-[#E3E3E3] rounded-[8px] px-2 py-1 bg-white text-[#204A80]'
														disabled={
															!publicoAlvoSelecionado ||
															isViewMode
														}
														onClick={() => {
															if (
																publicoAlvoSelecionado &&
																!form.publico_alvo.includes(
																	publicoAlvoSelecionado
																)
															) {
																setForm(
																	(prev) => ({
																		...prev,
																		publico_alvo:
																			[
																				...prev.publico_alvo,
																				publicoAlvoSelecionado,
																			],
																	})
																);
																setPublicoAlvoSelecionado(
																	''
																);
															}
														}}>
														+
													</button>
												</div>
												{showAddPublicoAlvo &&
													!isViewMode && (
														<div className='flex items-center gap-2 mt-2'>
															<input
																type='text'
																placeholder='Novo público-alvo'
																value={
																	novoPublicoAlvo
																}
																onChange={(e) =>
																	setNovoPublicoAlvo(
																		e.target
																			.value
																	)
																}
																className='bg-white border border-[#E3E3E3] rounded-[8px] px-3 py-2 outline-none flex-1'
																onKeyPress={(
																	e
																) =>
																	e.key ===
																		'Enter' &&
																	handleAddPublicoAlvo()
																}
															/>
															<button
																type='button'
																onClick={
																	handleAddPublicoAlvo
																}
																className='bg-[#42B9EB] text-white rounded-[8px] px-3 py-2 text-sm font-bold'>
																Adicionar
															</button>
														</div>
													)}
												{form.publico_alvo.length >
													0 && (
													<div className='flex flex-wrap gap-2 mt-2'>
														{form.publico_alvo.map(
															(
																publicoId,
																index
															) => (
																<span
																	key={`${publicoId}-${index}`}
																	className='bg-[#e3f7fd] text-[#204A80] px-2 py-1 rounded text-xs flex items-center'>
																	{publicoAlvoApi.some(
																		(p) =>
																			String(
																				p.id
																			) ===
																			String(
																				publicoId
																			)
																	)
																		? getPublicoAlvoNome(
																				publicoId
																		  )
																		: publicoId}
																	{!isViewMode && (
																		<button
																			type='button'
																			onClick={() =>
																				removePublicoAlvo(
																					publicoId
																				)
																			}
																			className='ml-1 text-[#D32F2F] text-xs'>
																			x
																		</button>
																	)}
																</span>
															)
														)}
														{publicoAlvoAdicionados.map(
															(publico, idx) => (
																<span
																	key={`adicionada-publico-${publico}-${idx}`}
																	className='bg-[#e3f7fd] text-[#204A80] px-2 py-1 rounded text-xs flex items-center'>
																	{publico}
																	{!isViewMode && (
																		<button
																			type='button'
																			onClick={() => {
																				setPublicoAlvoAdicionados(
																					publicoAlvoAdicionados.filter(
																						(
																							p
																						) =>
																							p !==
																							publico
																					)
																				);
																			}}
																			className='ml-1 text-[#D32F2F] text-xs'>
																			x
																		</button>
																	)}
																</span>
															)
														)}
													</div>
												)}
											</div>
										</div>

										<div className='flex flex-col flex-[3] w-full'>
											<label
												className='text-[#204A80] font-semibold mb-1'
												htmlFor='descricao'>
												Descrição
											</label>
											<textarea
												id='descricao'
												placeholder=''
												value={form.descricao}
												onChange={handleChange}
												// maxLength={500}
												className={`bg-white border resize-none rounded-[8px] px-3 py-3  outline-none h-[180px] w-full ${
													errors.descricao
														? 'border-[#D32F2F]'
														: 'border-[#E3E3E3]'
												}`}
												disabled={formDisabled}
											/>
										</div>

										<div className='h-[2px] w-full mt-[28px] mb-8 bg-[#E3E3E3]'></div>
										{/* Mensagem de erro */}
										{showErrorMsg && (
											<div className='text-[#D32F2F] text-center mb-4 font-medium'>
												Preencha os campos em destaque
											</div>
										)}
										{(successMsg ||
											requisitionError.length > 0) && (
											<div
												className={`${
													requisitionError
														? 'text-[#D32F2F]'
														: 'text-[#2E7D32]'
												} text-center mb-4 font-medium`}>
												{!requisitionError
													? 'Arquivo enviado para a Biblioteca'
													: requisitionError}
											</div>
										)}
										{/* Botão enviar centralizado */}
										{!isViewMode && (
											<div className='flex justify-center w-full mt-2'>
												<button
													type='submit'
													className='bg-[#FCFCFC] px-6 py-2 rounded-[8px] text-[#757575] enabled:hover:bg-[#004A80] enabled:hover:text-white font-semibold shadow border border-[#E3E3E3]'
													disabled={
														formDisabled ||
														loading ||
														successMsg
													}>
													{loading || successMsg ? (
														<svg
															aria-hidden='true'
															className='w-[80px] h-6 text-gray-200 animate-spin   fill-blue-600'
															viewBox='0 0 100 101'
															fill='none'
															xmlns='http://www.w3.org/2000/svg'>
															<path
																d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
																fill='currentColor'
															/>
															<path
																d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
																fill='currentFill'
															/>
														</svg>
													) : (
														'Salvar Arquivo'
													)}
												</button>
											</div>
										)}
									</form>
								</>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
